import { RouteComponentProps } from '@reach/router';
import React from 'react';
import api from '../../lib/Api';
import ReleaseItem, { ReleaseItemState } from '../../lib/models/ReleaseItem';
import Environment from './Environment';
import TrackedRelease from '../../lib/models/TrackedRelease';

interface ReleasesOverviewProps extends RouteComponentProps { }
interface ReleasesOverviewState {
    releaseItemState?: ReleaseItemState;
    trackedReleases: Map<string, Set<string>>;
}

export default class ReleasesOverview extends React.Component<ReleasesOverviewProps, ReleasesOverviewState> {
    public constructor(props: ReleasesOverviewProps) {
        super(props);

        this.state = { releaseItemState: undefined, trackedReleases: new Map() };

        Promise.all([ api.releaseItems.list(), api.trackedReleases.list() ]).then(([releaseItemState, tracked]) => {
            const newState: ReleasesOverviewState = { releaseItemState, trackedReleases: new Map() } ;

            newState.trackedReleases = new Map();
            tracked.forEach(item => {
                if (!newState.trackedReleases.has(item.name)) {
                    newState.trackedReleases.set(item.name, new Set());
                }

                newState.trackedReleases.get(item.name)!.add(item.version);
            });

            this.sortReleaseItems(newState);
            this.setState(newState);
        });
    }

    public render() {
        if (!this.state.releaseItemState || !Object.keys(this.state.releaseItemState).length) {
            return <div className='section container'>no releases found</div>;
        }

        return <div className='section container'>
            {Object.keys(this.state.releaseItemState).sort().map((group) =>
                <Environment
                    name={group}
                    trackedReleases={this.state.trackedReleases}
                    onToggleTrackedRelease={(release) => this.toggleTrackedRelease(release)}
                    group={this.state.releaseItemState![group]}
                    key={group} />)}
        </div>;
    }

    public toggleTrackedRelease(release: ReleaseItem) {
        const isTracked = this.state.trackedReleases.get(release.name)?.has(release.version) ?? false;
        const trackedRelease = new TrackedRelease({ name: release.name, version: release.version });
        const newState = {...this.state};

        if (isTracked) {
            newState.trackedReleases.get(release.name)?.delete(release.version);
            api.trackedReleases.delete(trackedRelease);
        }
        else {
            if (!newState.trackedReleases.has(release.name)) {
                newState.trackedReleases.set(release.name, new Set());
            }

            newState.trackedReleases.get(release.name)!.add(release.version);
            api.trackedReleases.add(trackedRelease);
        }

        this.sortReleaseItems(newState);
        this.setState(newState);
    }

    private sortReleaseItems(state: ReleasesOverviewState) {
        if (!state.releaseItemState) return;

        Object.keys(state.releaseItemState).forEach(env => {
            const group = state.releaseItemState![env];
            Object.keys(group).forEach(name => {
                group[name] = group[name].sort((a, b) => {
                    const trackedA = state.trackedReleases.get(a.name)?.has(a.version) ?? false;
                    const trackedB = state.trackedReleases.get(b.name)?.has(b.version) ?? false;

                    if (trackedA !== trackedB) {
                        return trackedA ? -1 : 1;
                    }

                    const dateA = new Date(a.deployedAt).getTime();
                    const dateB = new Date(b.deployedAt).getTime();
                    return dateB - dateA;
                });
            });
        });
    }
}